module.exports = __webpack_public_path__ + "mainassets/img/required.f9439238.svg";